import React from 'react';
import { createPortal } from 'react-dom';

export type NeisExportFormat = 'xls' | 'pdf';

export type NeisExportFormatPickModalProps = {
  open: boolean;
  title: string;
  onClose: () => void;
  onPick: (format: NeisExportFormat) => void;
  busy?: boolean;
};

const NeisExportFormatPickModal: React.FC<NeisExportFormatPickModalProps> = ({
  open,
  title,
  onClose,
  onPick,
  busy = false,
}) => {
  React.useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        if (!busy) onClose();
      }
    };
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [busy, onClose, open]);

  if (!open) return null;

  return createPortal(
    <div
      className="cp-modal-backdrop cp-neis-export-format-pick-backdrop"
      role="presentation"
      onMouseDown={(ev) => {
        if (ev.target === ev.currentTarget && !busy) onClose();
      }}
    >
      <div
        className="cp-modal cp-neis-export-format-pick-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-neis-export-format-pick-title"
        onMouseDown={(ev) => ev.stopPropagation()}
      >
        <div className="cp-modal-document-header cp-neis-export-format-pick-header">
          <h3 id="cp-neis-export-format-pick-title">{title}</h3>
          <button
            type="button"
            className="cp-modal-document-close-btn"
            onClick={onClose}
            disabled={busy}
            title="닫기"
            aria-label="닫기"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="cp-neis-export-format-pick-body">
          <p className="cp-neis-export-format-pick-desc">다운로드 파일 형식을 선택하세요.</p>
          <div className="cp-neis-export-format-pick-actions" role="group" aria-label="다운로드 파일 형식">
            <button
              type="button"
              className="cp-btn-primary cp-neis-export-format-pick-btn"
              onClick={() => onPick('xls')}
              disabled={busy}
            >
              xls
            </button>
            <button
              type="button"
              className="cp-btn-primary cp-neis-export-format-pick-btn"
              onClick={() => onPick('pdf')}
              disabled={busy}
            >
              pdf
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default NeisExportFormatPickModal;
